import { Typography, Separator, Checkbox, Button } from '@ui/components';
import { Cancel, Plus, Car } from '@ui/components/icons';
import { useTranslation } from 'react-i18next';

import { AddVehiclesHeader, VehiclePreview, VehiclesForm } from '../../containers';
import { useOnboardingVehicles } from './use-onboarding-vehicles';

export const OnboardingVehicles = () => {
  const { t } = useTranslation();
  const {
    isCompanyWithoutVehiclesSelectedCheckboxVisible,
    isCompanyWithoutVehiclesSelected,
    isVehiclesFormVisible,
    isSaveMutationPending,
    savedVehicles,
    form,
    checkIfRegistrationNumberIsUnique,
    toggleCompanyWithoutVehicles,
    handleSaveAndContinue,
    handleRemoveVehicle,
    closeVehiclesForm,
    handleEditVehicle,
    addNextVehicle,
    handleSubmit,
  } = useOnboardingVehicles();

  return (
    <>
      <AddVehiclesHeader className="mb-8" />

      {isCompanyWithoutVehiclesSelectedCheckboxVisible && (
        <div className="flex items-center gap-2 mb-6">
          <Checkbox
            onCheckedChange={toggleCompanyWithoutVehicles}
            checked={isCompanyWithoutVehiclesSelected}
            id="has-vehicles"
          />
          <Typography variant="labelMediumBook" asChild>
            <label htmlFor="has-vehicles">
              {t('ONBOARDING.ADD_VEHICLES.COMPANY_WITHOUT_VEHICLES')}
            </label>
          </Typography>
        </div>
      )}

      {savedVehicles.map((vehicle, idx) => (
        <VehiclePreview
          showSeparator={idx !== savedVehicles.length - 1 && isVehiclesFormVisible}
          checkIfRegistrationNumberIsUnique={checkIfRegistrationNumberIsUnique}
          handleEditVehicle={(vehicle) => handleEditVehicle(vehicle, idx)}
          handleRemoveVehicle={() => handleRemoveVehicle(idx)}
          key={vehicle.registrationNumber + idx}
          vehicleIndex={idx}
          vehicle={vehicle}
        />
      ))}

      {isVehiclesFormVisible && savedVehicles.length > 0 && (
        <div className="flex items-center gap-2 mb-6">
          <Car className="size-4    form.setValue('email', user?.email ?? '');" />
          <Typography variant="h100">
            {t('ONBOARDING.ADD_VEHICLES.VEHICLE')} {savedVehicles.length + 1}
          </Typography>

          <Button onClick={closeVehiclesForm} className="ml-auto" variant="ghost">
            <Cancel className="size-4" />
          </Button>
        </div>
      )}

      {isVehiclesFormVisible && (
        <VehiclesForm
          isFormDisabled={isCompanyWithoutVehiclesSelected}
          onSubmit={handleSubmit}
          form={form}
        />
      )}

      {!isCompanyWithoutVehiclesSelected && (
        <>
          <Separator className="my-8" />
          <Button onClick={addNextVehicle} variant="secondary" size="large" wide>
            {t('ONBOARDING.ADD_VEHICLES.ADD_NEXT_VEHICLE')}
            <Plus className="size-4" />
          </Button>
        </>
      )}

      <Separator className="my-8" />
      <Button
        isLoading={isSaveMutationPending}
        disabled={isSaveMutationPending}
        onClick={handleSaveAndContinue}
        variant="primary"
        size="large"
        wide
      >
        {t('ONBOARDING.ADD_VEHICLES.SAVE_AND_CONTINUE')}
      </Button>
    </>
  );
};
